import {
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  Stack,
  MenuItem,
  Typography,
} from "@mui/material";
import { useState, useEffect } from "react";
import KsbDialogActions from "../../../../2_ksbHub/components/KsbDialogActions";

export default function AddJobDialog({
  open,
  onClose,
  onSave,
  shifts,
  initialData,
}) {
  const isEditMode = !!initialData;

  const [title, setTitle] = useState("");
  const [shiftId, setShiftId] = useState("");
  const [leitungSlots, setLeitungSlots] = useState(1);
  const [teamSlots, setTeamSlots] = useState(0);
  const [error, setError] = useState("");

  // ✅ populate values when editing
  useEffect(() => {
    if (initialData) {
      setTitle(initialData.title);
      setShiftId(initialData.shiftId);
      setLeitungSlots(initialData.leitungSlots);
      setTeamSlots(initialData.teamSlots);
    } else {
      // reset when opening for create
      setTitle("");
      setShiftId("");
      setLeitungSlots(1);
      setTeamSlots(0);
    }
  }, [initialData, open]);

  // ✅ save handler
  const handleSave = async () => {
    if (!title || !shiftId) {
      setError("Bitte Titel und Schicht angeben.");
      return;
    }

    const jobData = {
      id: initialData?.id,
      title,
      shiftId,
      leitungSlots: Number(leitungSlots),
      teamSlots: Number(teamSlots),
    };

    try {
      setError("");

      await onSave(jobData);

      onClose();
    } catch (err) {
      console.error(err);

      setError("Fehler beim Speichern. Bitte erneut versuchen.");
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth>
      <DialogTitle>{isEditMode ? "Job bearbeiten" : "Neuer Job"}</DialogTitle>

      <DialogContent>
        {error && (
          <Typography
            sx={{
              color: "error.main",
              fontSize: "0.85rem",
              mb: 1,
            }}
          >
            {error}
          </Typography>
        )}
        <Stack spacing={2} mt={1}>
          <TextField
            label="Job Titel"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            fullWidth
          />

          <TextField
            select
            label="Schicht"
            value={shiftId}
            onChange={(e) => setShiftId(e.target.value)}
            fullWidth
          >
            {shifts.map((shift) => (
              <MenuItem key={shift.id} value={shift.id}>
                {shift.label} ({shift.time})
              </MenuItem>
            ))}
          </TextField>

          <TextField
            label="Anzal Leitung Slots"
            type="number"
            value={leitungSlots}
            onChange={(e) => setLeitungSlots(e.target.value)}
            fullWidth
          />

          <TextField
            label="Anzahl Schüler Slots"
            type="number"
            value={teamSlots}
            onChange={(e) => setTeamSlots(e.target.value)}
            fullWidth
          />
        </Stack>
      </DialogContent>

      <KsbDialogActions
        onCancel={onClose}
        onConfirm={handleSave}
        confirmLabel={isEditMode ? "Speichern" : "Erstellen"}
        confirmDisabled={!title.trim()}
      />
    </Dialog>
  );
}
